

import VideoPlayer from './videoplayer';


// let video = document.querySelectorAll('[data-video]');

// if (video) {
//     let player = new VideoPlayer(video),
//         title = document.querySelector('#videoTitle');

//     title && (title.style.left = '0');

//     player.addEvent('play', function() {
//         console.log('PLAY', title.classList);
//         title.style.left = '-50vw';
//     });

//     player.addEvent('pause', function() {
//         console.log('PAUSE', title.classList);
//         title.style.left = '0';
//     });
// }


!function(selector){
    [...document.querySelectorAll(selector)].forEach((node)=>{
        new VideoPlayer(node);
    });
}('[data-video]');